<template>
  <div class="features-highlight footer">
    <div class="container-fluid">
      <div class="row py-3">
        <div class="col-12 mt-4 mt-md-0 col-md-3 order-4 order-md-0">
          <div class="text-secondary text-center">© PyCrunch 2020</div>
        </div>
        <div class="col-12 col-md-6 ">
          <div class="text-center"><a href="https://github.com/gleb-sevruk/pycrunch-trace" target="_blank">Visit
            GitHub</a> for more information
          </div>
        </div>
        <div class="col-12 mt-4 mt-sm-0 col-md-3 ">
          <div class="text-secondary text-center"><a href="mailto:support@pycrunch.com">support@pycrunch.com</a></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'pc-footer',
  }
</script>
<style scoped>

  .features-highlight {
    background-color: #eaeaec;
  }
  .footer {
    margin-top: auto;
  }

</style>